// English
import homeEN from './en/home.json';
import accountEN from './en/account.json';
import areaEN from './en/area.json';
import assetEN from './en/asset.json';
import authEN from './en/auth.json';
import colorsEN from './en/colors.json';
import daysEN from './en/days.json';
import documentEN from './en/document.json';
import formEN from './en/form.json';
import frequencyEN from './en/frequency.json';
import howToUseEN from './en/howToUse.json';
import interventionEN from './en/intervention.json';
import measureEN from './en/measure.json';
import noDataEN from './en/noData.json';
import pagesEN from './en/pages.json';
import qrEN from './en/qr.json';
import sectorEN from './en/sector.json';
import siteEN from './en/site.json';
import taskEN from './en/task.json';
import teamEN from './en/team.json';
import upgradeEN from './en/upgrade.json';
import translationEN from './en/translation.json';
import validationEN from './en/validation.json';
import pluralsEN from './en/plurals.json';
// France
import homeFR from './fr/home.json';
import accountFR from './fr/account.json';
import areaFR from './fr/area.json';
import assetFR from './fr/asset.json';
import authFR from './fr/auth.json';
import colorsFR from './fr/colors.json';
import daysFR from './fr/days.json';
import documentFR from './fr/document.json';
import formFR from './fr/form.json';
import frequencyFR from './fr/frequency.json';
import howToUseFR from './fr/howToUse.json';
import interventionFR from './fr/intervention.json';
import measureFR from './fr/measure.json';
import noDataFR from './fr/noData.json';
import pagesFR from './fr/pages.json';
import qrFR from './fr/qr.json';
import sectorFR from './fr/sector.json';
import siteFR from './fr/site.json';
import taskFR from './fr/task.json';
import teamFR from './fr/team.json';
import upgradeFR from './fr/upgrade.json';
import translationFR from './fr/translation.json';
import validationFR from './fr/validation.json';
import pluralsFR from './fr/plurals.json';
// Romania
import homeRO from './ro/home.json';
import accountRO from './ro/account.json';
import areaRO from './ro/area.json';
import assetRO from './ro/asset.json';
import authRO from './ro/auth.json';
import colorsRO from './ro/colors.json';
import daysRO from './ro/days.json';
import documentRO from './ro/document.json';
import formRO from './ro/form.json';
import frequencyRO from './ro/frequency.json';
import howToUseRO from './ro/howToUse.json';
import interventionRO from './ro/intervention.json';
import measureRO from './ro/measure.json';
import noDataRO from './ro/noData.json';
import pagesRO from './ro/pages.json';
import qrRO from './ro/qr.json';
import sectorRO from './ro/sector.json';
import siteRO from './ro/site.json';
import taskRO from './ro/task.json';
import teamRO from './ro/team.json';
import upgradeRO from './ro/upgrade.json';
import translationRO from './ro/translation.json';
import validationRO from './ro/validation.json';
import pluralsRO from './ro/plurals.json';
// Ukraine
import homeUK from './uk/home.json';
import accountUK from './uk/account.json';
import areaUK from './uk/area.json';
import assetUK from './uk/asset.json';
import authUK from './uk/auth.json';
import colorsUK from './uk/colors.json';
import daysUK from './uk/days.json';
import documentUK from './uk/document.json';
import formUK from './uk/form.json';
import frequencyUK from './uk/frequency.json';
import howToUseUK from './uk/howToUse.json';
import interventionUK from './uk/intervention.json';
import measureUK from './uk/measure.json';
import noDataUK from './uk/noData.json';
import pagesUK from './uk/pages.json';
import qrUK from './uk/qr.json';
import sectorUK from './uk/sector.json';
import siteUK from './uk/site.json';
import taskUK from './uk/task.json';
import teamUK from './uk/team.json';
import upgradeUK from './uk/upgrade.json';
import translationUK from './uk/translation.json';
import validationUK from './uk/validation.json';
import pluralsUK from './uk/plurals.json';
// Poland
import homePL from './pl/home.json';
import accountPL from './pl/account.json';
import areaPL from './pl/area.json';
import assetPL from './pl/asset.json';
import authPL from './pl/auth.json';
import colorsPL from './pl/colors.json';
import daysPL from './pl/days.json';
import documentPL from './pl/document.json';
import formPL from './pl/form.json';
import frequencyPL from './pl/frequency.json';
import howToUsePL from './pl/howToUse.json';
import interventionPL from './pl/intervention.json';
import measurePL from './pl/measure.json';
import noDataPL from './pl/noData.json';
import pagesPL from './pl/pages.json';
import qrPL from './pl/qr.json';
import sectorPL from './pl/sector.json';
import sitePL from './pl/site.json';
import taskPL from './pl/task.json';
import teamPL from './pl/team.json';
import upgradePL from './pl/upgrade.json';
import translationPL from './pl/translation.json';
import validationPL from './pl/validation.json';
import pluralsPL from './pl/plurals.json';
// Spain
import homeES from './es/home.json';
import accountES from './es/account.json';
import areaES from './es/area.json';
import assetES from './es/asset.json';
import authES from './es/auth.json';
import colorsES from './es/colors.json';
import daysES from './es/days.json';
import documentES from './es/document.json';
import formES from './es/form.json';
import frequencyES from './es/frequency.json';
import howToUseES from './es/howToUse.json';
import interventionES from './es/intervention.json';
import measureES from './es/measure.json';
import noDataES from './es/noData.json';
import pagesES from './es/pages.json';
import qrES from './es/qr.json';
import sectorES from './es/sector.json';
import siteES from './es/site.json';
import taskES from './es/task.json';
import teamES from './es/team.json';
import upgradeES from './es/upgrade.json';
import translationES from './es/translation.json';
import validationES from './es/validation.json';
import pluralsES from './es/plurals.json';

const resources = {
  en: {
    translation: {
      home: homeEN,
      ...accountEN,
      ...areaEN,
      ...assetEN,
      ...authEN,
      ...colorsEN,
      ...daysEN,
      ...documentEN,
      ...formEN,
      ...frequencyEN,
      ...howToUseEN,
      ...interventionEN,
      ...measureEN,
      ...noDataEN,
      ...pagesEN,
      ...qrEN,
      ...sectorEN,
      ...siteEN,
      ...taskEN,
      ...teamEN,
      ...upgradeEN,
      ...translationEN,
      ...validationEN,
      ...pluralsEN,
    },
  },
  fr: {
    translation: {
      home: homeFR,
      ...accountFR,
      ...areaFR,
      ...assetFR,
      ...authFR,
      ...colorsFR,
      ...daysFR,
      ...documentFR,
      ...formFR,
      ...frequencyFR,
      ...howToUseFR,
      ...interventionFR,
      ...measureFR,
      ...noDataFR,
      ...pagesFR,
      ...qrFR,
      ...sectorFR,
      ...siteFR,
      ...taskFR,
      ...teamFR,
      ...upgradeFR,
      ...translationFR,
      ...validationFR,
      ...pluralsFR,
    },
  },
  ro: {
    translation: {
      home: homeRO,
      ...accountRO,
      ...areaRO,
      ...assetRO,
      ...authRO,
      ...colorsRO,
      ...daysRO,
      ...documentRO,
      ...formRO,
      ...frequencyRO,
      ...howToUseRO,
      ...interventionRO,
      ...measureRO,
      ...noDataRO,
      ...pagesRO,
      ...qrRO,
      ...sectorRO,
      ...siteRO,
      ...taskRO,
      ...teamRO,
      ...upgradeRO,
      ...translationRO,
      ...validationRO,
      ...pluralsRO,
    },
  },
  uk: {
    translation: {
      home: homeUK,
      ...accountUK,
      ...areaUK,
      ...assetUK,
      ...authUK,
      ...colorsUK,
      ...daysUK,
      ...documentUK,
      ...formUK,
      ...frequencyUK,
      ...howToUseUK,
      ...interventionUK,
      ...measureUK,
      ...noDataUK,
      ...pagesUK,
      ...qrUK,
      ...sectorUK,
      ...siteUK,
      ...taskUK,
      ...teamUK,
      ...upgradeUK,
      ...translationUK,
      ...validationUK,
      ...pluralsUK,
    },
  },
  pl: {
    translation: {
      home: homePL,
      ...accountPL,
      ...areaPL,
      ...assetPL,
      ...authPL,
      ...colorsPL,
      ...daysPL,
      ...documentPL,
      ...formPL,
      ...frequencyPL,
      ...howToUsePL,
      ...interventionPL,
      ...measurePL,
      ...noDataPL,
      ...pagesPL,
      ...qrPL,
      ...sectorPL,
      ...sitePL,
      ...taskPL,
      ...teamPL,
      ...upgradePL,
      ...translationPL,
      ...validationPL,
      ...pluralsPL,
    },
  },
  es: {
    translation: {
      home: homeES,
      ...accountES,
      ...areaES,
      ...assetES,
      ...authES,
      ...colorsES,
      ...daysES,
      ...documentES,
      ...formES,
      ...frequencyES,
      ...howToUseES,
      ...interventionES,
      ...measureES,
      ...noDataES,
      ...pagesES,
      ...qrES,
      ...sectorES,
      ...siteES,
      ...taskES,
      ...teamES,
      ...upgradeES,
      ...translationES,
      ...validationES,
      ...pluralsES,
    },
  },
};

export default resources;
